<h2 mat-dialog-title>Public Message</h2>

<mat-dialog-content>

   <p>Type a message here that other players will see. For example, that you are injured for a week or two, or
      going out of town until Thanksgiving.... </p>
   <input type="text" style="width: 100%;" maxlength="30" [(ngModel)]="message" />
</mat-dialog-content>

<mat-dialog-actions style="float: right;">
   <a href="#" (click)="cancel()">Cancel</a>
   &nbsp;&nbsp;
   <button class="" (click)="save()">Save</button>
</mat-dialog-actions>